import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";

import TabsComponentNotesLevel from "@/Components/TreatmentPage/TabsComponentNotesLevel";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import { setHasNoData } from "../Redux/Directory/directorySlice";
import Footer from "../Components/common/footer";
import { fetchStates } from "../Redux/states/statesSlice";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import CaseMerge from "../Components/LawFirmDirectoryDashboard/case-merge/case-merge";
import LawFirmDirectoryDashboard from "../Components/LawFirmDirectoryDashboard/main";
import ClientMerge from "../Components/FirmSettings/client-merge/client-merge";
import LetterTemplates from "../Components/FirmSettings/letter-templates/letter-templates";
import ESignature from "../Components/FirmSettings/e-signature";
import AutoTaskTabs from "../Components/FirmSettings/auto-taks-tab/new-auto-task-tab";
import { FIRM_MANAGEMENT_TABS } from "../Routes/firmManagement.mjs";
import "../Components/FirmSettings/FirmSettings.css";
import "../Components/FirmSettings/TemplateTabs.css";

function LawFirmDirectory() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);
  const requestedTab = searchParams.get("tab_id") || location.state?.firmManagementTab;
  const activeTab = FIRM_MANAGEMENT_TABS.some((tab) => tab.id === requestedTab)
    ? requestedTab
    : "directory";
  const [caseMergeBusy, setCaseMergeBusy] = useState(false);
  const tabsData = FIRM_MANAGEMENT_TABS.map((tab) => ({
    ...tab,
    onClick: () => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("tab_id", tab.id);
      setSearchParams(nextParams);
    },
  }));

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 45).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    dispatch(setHasNoData(false));
    dispatch(fetchStates());
    // sending page ids directly now.
    fetchShakespeareStatus(getCaseId(), 45, dispatch);
  }, [dispatch]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div
        className={`page-wrapper firm-management-page ${sideBarCollapsed ? "force-collapsed" : ""}`}
      >
        <Sidebar />
        <div className="page-container">
          <NavBar flaggedPageName={"45"} />

          <div className="main-content firm-management-content">
            <div className="height-35 position-relative me-0 flex-shrink-0">
              <ActionBarComponent
                src="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/directory-logo-icon.svg"
                page_name={pageObject?.name}
                pageObj={pageObject}
                isChecklist={pageObject?.PageChklst || false}
              />
            </div>
            <div className="firm-management-tabs">
              <TabsComponentNotesLevel
                handlePage={activeTab}
                tabsData={tabsData}
                height={25}
                doesHaveAll={false}
                labelClass="ps-0"
                disabled={caseMergeBusy}
                controlledActiveTab
              />
            </div>

            {FIRM_MANAGEMENT_TABS.map((tab) => (
              <div
                key={tab.id}
                className="firm-management-panel"
                id={`firm-management-panel-${tab.id}`}
                role="tabpanel"
                aria-labelledby={`firm-management-tab-${tab.id}`}
                hidden={activeTab !== tab.id}
                tabIndex={0}
              >
                {tab.id === "directory" && <LawFirmDirectoryDashboard />}
                {tab.id === "case-merge" && <CaseMerge onBusyChange={setCaseMergeBusy} />}
                {activeTab === tab.id && tab.id === "client-merge" && <ClientMerge />}
                {activeTab === tab.id && tab.id === "templates" && <LetterTemplates />}
                {activeTab === tab.id && tab.id === "electronic-signature" && <ESignature />}
                {activeTab === tab.id && tab.id === "auto-tasks" && <AutoTaskTabs />}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LawFirmDirectory;
